// @ts-ignore
import { GandalfArray } from 'gandalf';
// @ts-ignore
import { GandalfConstantDecorator } from 'gandalf';
// @ts-ignore
import { GandalfLabel } from 'gandalf';
// @ts-ignore
import { GandalfModel } from 'gandalf';
// @ts-ignore
import { GandalfModelBase } from 'gandalf';
// @ts-ignore
import { GandalfProperty } from 'gandalf';
// @ts-ignore
import { GandalfSubRequestLabel } from 'gandalf';
// @ts-ignore
import { GandalfValidator } from 'gandalf';
// @ts-ignore
import * as constants from '../constants';


/** See com.rev360.pms.api.controller.laborder.LoincCodeRequest */
/* istanbul ignore next */
@GandalfModel
export class LoincCodeRequest extends GandalfModelBase {

	@GandalfValidator({ notNull: { message: 'LOINC is required' } })
	@GandalfValidator({ sizeString: { fieldLabel: 'LOINC', maxLength: 1000, minLength: 0, message: 'LOINC must be less than or equal to 1000 characters' } })
	@GandalfProperty({ designType: String, isRequired: true })
	loincNum!: string;

}
